// Lets API clients tell the app that nobody is signed in any more (a 401), so it shows the
// sign-in page; the app subscribes in AuthGate
const listeners = new Set();

export const onUnauthorized = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const notifyUnauthorized = () => {
  listeners.forEach(listener => listener());
};
